/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useAppRollenContext } from "../../../../Basis/Components/AppRollenContext";

export type QueryResult<T> =
    | { loading: true }
    | { loading: false, data: T };

export function nurEigentuemer<Props extends { children?: React.ReactNode }>(Component: React.FC<Props>) {
    function Wrapper(props: Props) {
        const appRollenContext = useAppRollenContext();
        if (appRollenContext.istEigentuemerOderSupport) {
            return <Component {...props} />;
        }

        return <>{props.children}</>;
    }

    return Wrapper;
}
